// extracted by mini-css-extract-plugin
export default {"root":"CompanyValues_root__r9Efo","swiper-slide":"CompanyValues_swiper-slide__9AgOM","left":"CompanyValues_left__Kpjc+","right":"CompanyValues_right__xQ+uD"};